import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute, Router } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { Atividade } from 'src/app/core/atividade';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { AtividadeService } from 'src/app/services/atividade/atividade.service';
import { FiltroAtividade } from "../../core/filtro/filtro-atividade";
import { DataUtilService } from "../../services/commons/data-util.service";
import { ConfirmDialogComponent } from '../common/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'oficina',
  templateUrl: './oficina.component.html',
  styleUrls: ['./oficina.component.css']
})
export class OficinaComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  filtro: FiltroAtividade = new FiltroAtividade();
  oficina: Atividade = new Atividade();

  mostrarTabela = false;
  msg: string;

  displayedColumns: string[] = ['descricao', 'datainicio', 'datafim', 'maxparticipantes', 'acoes'];
  dataSource: MatTableDataSource<Atividade> = new MatTableDataSource();

  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  menu: string;
  area: string;
  constructor(
    private oficinaService: AtividadeService,
    private router: Router,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private dataUtilService: DataUtilService
  ) { }

  ngOnInit() {
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);
    this.dataSource.paginator = this.paginator;
    this.area = this.getArea();
    this.filtro.area = this.area;
    this.consultar();
  }

  getMenu(): string {
    const primeiroSegmento = this.router.url.split('/')[1];
    return primeiroSegmento.startsWith('menu') ? primeiroSegmento : undefined;
  }

  private getArea(): string {
    this.menu = this.getMenu();
    return this.menu && this.menu == "menu-sap" ? 'S' : (this.menu && this.menu == "menu-pedagogico" ? 'P' : null);
  }

  limpar() {
    this.mostrarTabela = false;
    this.dataSource.data = [];
    this.msg = '';

    this.filtro = new FiltroAtividade();
  }

  consultar() {
    if (this.filtro.descricao ||
        this.filtro.projeto ||
        this.filtro.dataInicio ||
        this.filtro.dataFim) {
      this.oficinaService.getByFilter(this.filtro).subscribe((oficinas: Atividade[]) => {
        if (!oficinas || oficinas.length === 0) {
          this.mostrarTabela = false;
          this.msg = 'Nenhum registro para a pesquisa selecionada';
        } else {
          oficinas = oficinas.filter(o => !o.idTurma)
          .sort((a, b) => new Date(b.dataInicio).getTime() - new Date(a.dataInicio).getTime());


          this.dataSource.data = oficinas ? oficinas : [];
          this.mostrarTabela = true;
          this.verificaMostrarTabela(oficinas);
        }
      });
    } else {
      this.oficinaService.getAllByArea(this.filtro.area).subscribe((oficinas: Atividade[]) => {
        oficinas = oficinas.filter(o => !o.idTurma)
        .sort((a, b) => new Date(b.dataInicio).getTime() - new Date(a.dataInicio).getTime());

        this.dataSource.data = oficinas ? oficinas : [];
        this.mostrarTabela = true;
        this.verificaMostrarTabela(oficinas);
      });
    }
  }


  verificaMostrarTabela(oficinas: Atividade[]) {
    if (!oficinas || oficinas.length === 0) {
      this.mostrarTabela = false;
      this.msg = 'Nenhuma oficina cadastrada.';
    } else {
      this.mostrarTabela = true;
    }
  }


  atualizar(oficina: Atividade) {
    oficina.area = this.area;
    const rota = this.menu ? this.menu+'/oficinas/cadastrar':'oficinas/cadastrar';
    this.router.navigate([rota], { queryParams: { id: oficina.id } });
  }

  deletar(oficina: Atividade) {
    this.chamaCaixaDialogo(oficina);
  }

  chamaCaixaDialogo(oficina: Atividade) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      pergunta: `Certeza que deseja excluir a oficina ?`,
      textoConfirma: 'SIM',
      textoCancela: 'NÃO'
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirma => {
      if (confirma) {
        this.oficinaService.excluir(oficina.id).subscribe(() => {
          this.consultar();
        });
      } else {
        dialogRef.close();
      }
    }
    );
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

  onValorChangeProjeto(event: any) {
    this.filtro.projeto = event;
  }

}
